import React, { useState } from 'react';
import Header from '../header/header';
import { Outlet } from 'react-router-dom';
import './layout.scss';
import Sidebar from '../sidebar/sidebar';

export default function Layout() {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
        const storedState = localStorage.getItem('sidebarCollapsed');
        return storedState ? JSON.parse(storedState) : false;
    });

    const handleSidebarToggle = (collapsed) => {
        setIsSidebarCollapsed(collapsed);
    };

    return (
        <>
            <div className={`main-wrapper`}>
                <div className='layout-header-wrapper'>
                    <Header />
                </div>
                <div className={`content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
                    <div className={`sidebar-menu ${isSidebarCollapsed ? 'collapsed' : ''}`}>
                        <Sidebar onToggle={handleSidebarToggle} />{/* Pass toggle function */}
                    </div>
                    <div className={`dashboard-components-holder ${isSidebarCollapsed ? 'collapsed' : ''}`}>
                        <Outlet />
                    </div>
                </div>
            </div>
        </>
    );
}